export default "__VITE_ASSET__edd7b9e6__"